import { apiClient,web3Client } from '../../api/clients'
const environment = process.env.REACT_APP_WALLET_TYPE;
//Merchant
const getMerchantLU = (cutomerId) => {
    if(environment === 'non_custodial'){
        return web3Client.get(`Merchant/GetMerchantDetails/${cutomerId}`);
    }else{
        return apiClient.get(`Merchant/GetMerchantDetails/${cutomerId}`);
    }
}
const saveMerchant = (obj) => {
    if(environment === 'non_custodial'){
        return web3Client.post(`Merchant/MerchantSave`, obj);
    }else{
        return apiClient.post(`Merchant/MerchantSave`, obj);
    }
};
//dashboard
const getAVailableBalances = (coinName,customerId) =>{
    if(environment === 'non_custodial'){
        return web3Client.get(`Merchant/availablebalance/${coinName}/${customerId}`);
    }else{
        return apiClient.get(`Merchant/availablebalance/${coinName}/${customerId}`);
    }
}
const getGridData = (url,customerId) =>{
    if(environment === 'non_custodial'){
        return web3Client.get(`${url}/${customerId}/1/10`);
    }else{
        return apiClient.get(`${url}/${customerId}/1/10`);
    }
}
const getTransactions=(id,type,pageNo,pageSize)=>{
    if(environment === 'non_custodial'){
        return web3Client.get(`wallets/transactions/${id}/${type}?page=${pageNo}&pageSize=${pageSize}`)
    }else{
        return apiClient.get(`wallets/transactions/${id}/${type}?page=${pageNo}&pageSize=${pageSize}`)
    }
}
const getRecentPayments=(id,search,pageNo,pageSize,transactionType,fromDate,toDate)=>{
    if(environment === 'non_custodial'){
        return web3Client.get(`Merchant/payments/${id}/${transactionType}/${search}/${fromDate}/${toDate}?page=${pageNo}&pageSize=${pageSize}`)
    }else{
        return apiClient.get(`Merchant/payments/${id}/${transactionType}/${search}/${fromDate}/${toDate}?page=${pageNo}&pageSize=${pageSize}`)
    }
}
const getNotification=(url,customerId,type,obj)=>{
    if(environment === 'non_custodial'){
        return web3Client.get(`${url}/${customerId}/${type}`)
    }else{
        return apiClient.get(`${url}/${customerId}/${type}`)
    }
}
const get = (url) =>{
    if(environment === 'non_custodial'){
        return web3Client.get(`${url}`);
    }else{
        return apiClient.get(`${url}`);
    }
}
// commission
const getCommissionData = (url,customerId) =>{
    if(environment === 'non_custodial'){
        return web3Client.get(`${url}/${customerId}`);
    }else{
        return apiClient.get(`${url}/${customerId}`);
    }
}
export { getMerchantLU ,saveMerchant,getAVailableBalances,getGridData,getTransactions,get,getRecentPayments,getNotification,getCommissionData}
